import { FAQS_PAGE_FLAG } from '~/common/models/featureFlags.model';
import {
  SUPPORT_CONTACT_PATH,
  SUPPORT_FAQS_PATH,
} from '~/common/models/pages/supportPages.model';
import { RouteName } from '~/common/models/route.model';
import { lazyWithReload } from '~/common/utils/lazyWithReload';

const SupportContactView = lazyWithReload(
  () => import('~/routes/support/ContactViewFlagWrapper')
);
const FAQsView = lazyWithReload(() => import('~/routes/support/faqs/FAQsView'));

export const SUPPORT_ROUTES = {
  [RouteName.SUPPORT_CONTACT]: {
    name: RouteName.CS_PLATFORM_SUPPORT_CONTACT,
    path: SUPPORT_CONTACT_PATH,
    authorizedPerms: [],
    element: SupportContactView,
  },
  [RouteName.FAQS]: {
    name: RouteName.FAQS,
    path: SUPPORT_FAQS_PATH,
    authorizedPerms: [],
    element: FAQsView,
    requiredFeatureFlags: [FAQS_PAGE_FLAG],
  },
};
